import { useQuery, useMutation, gql } from "@apollo/client";

const NOTIFICATIONS_QUERY = gql`
  query Notifications {
    notifications(read: null) {
      edges {
        node {
          id
          message
          readAt
          createdAt
        }
      }
    }
    unreadNotifications {
      id
    }
  }
`;

const MARK_AS_READ_MUTATION = gql`
  mutation MarkNotificationAsRead($id: ID!) {
    markNotificationAsRead(id: $id) {
      id
      readAt
    }
  }
`;

const MARK_ALL_AS_READ_MUTATION = gql`
  mutation MarkAllNotificationsAsRead {
    markAllNotificationsAsRead
  }
`;

const DELETE_NOTIFICATION_MUTATION = gql`
  mutation DeleteNotification($id: ID!) {
    deleteNotification(id: $id) {
      success
      message
    }
  }
`;

export function useDeleteNotification() {
  const [deleteNotificationMutation, { loading, error }] = useMutation(DELETE_NOTIFICATION_MUTATION);
  const deleteNotification = async (id: string) => {
    return deleteNotificationMutation({ variables: { id } });
  };
  return { deleteNotification, loading, error };
}

export function useNotifications() {
  const { data, loading, error, refetch } = useQuery(NOTIFICATIONS_QUERY, { fetchPolicy: "cache-and-network" });
  const [markAsReadMutation] = useMutation(MARK_AS_READ_MUTATION);
  const [markAllAsReadMutation] = useMutation(MARK_ALL_AS_READ_MUTATION);

  const notifications =
    data?.notifications?.edges?.map((e: any) => ({
      ...e.node,
      timeAgo: new Date(e.node.createdAt).toLocaleString(),
    })) || [];
  const unreadCount = data?.unreadNotifications?.length || 0;

  const markAsRead = async (id: string) => {
    await markAsReadMutation({ variables: { id } });
    refetch();
  };
  const markAllAsRead = async () => {
    await markAllAsReadMutation();
    refetch();
  };

  return { notifications, unreadCount, markAsRead, markAllAsRead, loading, error, refetch };
}
